<template>
  <div class="m-mobile-table m-table m-table--large">
    <table>
      <thead>
        <tr class="m-table__row">
          <th class="m-table__col">{{ $t('business-list-business-label') }}</th>
          <th class="m-table__col">{{ $t('business-list-entrepeneurs-label') }}</th>
          <th class="m-table__col">{{ $t('business-list-isRegistered-label') }}</th>
          <th class="m-table__col">{{ $t('business-list-isPublish-label') }}</th>
          <th class="m-table__col m-table__col--right">
            <button class="a-btn-primary a-btn-primary--small" v-if="hasSomeToRegister" @click="registerAllBusiness" type="button">{{ $t('business-registerall-btn') }}</button>
          </th>
        </tr>
      </thead>
      <business-list-item v-for="business in value" :key="business.Id" :business="business" :entrepreneurs="entrepreneurs" />
    </table>
  </div>
</template>

<script>
import BusinessListItem from '@/components/dashboard/business/business-list-item'
import i18n from '@/helpers/i18n'
import SnipcartService from '@/services/snipcart'

const isNotRegistered = business => business.IsRegistered === false

export default {
  components: {
    BusinessListItem
  },
  props: {
    value: {
      type: Array,
      required: true
    },
    entrepreneurs: {
      type: Array,
      required: true
    }
  },
  computed: {
    hasSomeToRegister: function() {
      return this.value.filter(isNotRegistered).length > 1
    }
  },
  methods: {
    registerAllBusiness: function() {
      if (confirm(i18n.t('business-registerall-confirm'))) {
        let i
        for (i = 0; i < this.value.length; i++) {
          let itm = this.value[i]
          SnipcartService.addBusinessToCart(itm.Id, itm.Name, true)
        }
      }
    }
  }
}
</script>

<style lang="scss">
/* Override m-table look for mobile only */
@media screen and (max-width: 991px) {
  .m-mobile-table {
    table,
    thead,
    tbody,
    th,
    td,
    tr {
      display: block;
    }

    thead {
      border-bottom: 0;
    }

    thead tr {
      position: absolute;
      top: -9999px;
      left: -9999px;
    }

    tbody {
      tr {
        margin: 0 0 16px 0;
        border: 2px solid #c9c9c9;
        padding: 0 24px;
      }
    }

    td {
      border: 0;
      border-bottom: 1px solid #c9c9c9;
      position: relative;
      padding: 48px 0 16px;

      &:first-child {
        padding-left: 0;
      }

      &:last-child {
        padding-right: 0;
        border-bottom: 0;
        padding-top: 16px;
      }
    }

    td:before {
      content: attr(data-table-col-label);
      position: absolute;
      top: 12px;
      left: 0;
      width: 100%;
      white-space: nowrap;
      font-weight: bold;
    }
  }
}
</style>
